module.exports = __webpack_public_path__ + "img/ic_close_menu.195f5954.svg";